import { ActivatedRoute } from '@angular/router';
import { NavService } from './../nav/service/nav.service';
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { ArticleCardLoadingComponent } from '../shared/components/article-card-loading/article-card-loading.component';
import { LazyLoadDirective } from '../shared/directives/lazy-load.directive';
import {
  Article,
  Destination,
  Tag,
  ArticleType,
  ArticleCategory,
  ArticleService,
  DestinationService,
} from '../admin/shared/public-api';
import { environment } from '../../environments/environment';
import { DeviceService } from '../shared/services/device.service';
import { MetaService } from '../shared/services/meta.service';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    ArticleCardComponent,
    ArticleCardLoadingComponent,
    LazyLoadDirective,
  ],
})
export class ArticlesComponent implements OnInit {
  destinationService = inject(DestinationService);
  articleService = inject(ArticleService);
  private navService = inject(NavService);
  protected deviceService = inject(DeviceService);
  readonly metaTagService = inject(MetaService);

  articles: Article[];
  destinations: Destination[];
  selectedDestination: Destination;
  tags: Tag[];
  selectedTags: Tag[] = [];
  multiSelectFilterDefaultLabels = 'Filtre 2 —';
  articleType: ArticleType;
  loading = true;
  endLazyLoading = false;
  h1: string;
  description: string;
  TAKE = 6;
  title: string;

  ArticleType = ArticleType;

  constructor(route: ActivatedRoute, titleService: Title) {
    if (route.snapshot.data && route.snapshot.data['name']) {
      this.h1 = route.snapshot.data['h1'];
      this.description = route.snapshot.data['description'];
      this.title = route.snapshot.data['title'];
      this.articleType = route.snapshot.data['articleType'];

      //#region SEO
      const baseUrl = environment.baseUrl;
      // Get the current path from the activated route
      const currentPath = '/' + route.snapshot.url.map((segment) => segment.path).join('/');
      let url = `${baseUrl}${currentPath}`;

      titleService.setTitle(this.title);
      this.metaTagService.updateMetaTags(
        this.description,
        this.title,
        url,
        'website',
        `${baseUrl}og_img.png`,
        768,
        432,
        'image/png',
      );
      //#endregion
    }
  }

  ngOnInit(): void {
    this.navService.setGreenBackground();
    this.loadArticles();
  }

  loadArticles(): void {
    this.articles = [];
    const destinationObservable = this.destinationService.getDestinations();
    this.getArticles();

    destinationObservable.subscribe((res) => {
      this.destinations = res.sort((a, b) => a.country.localeCompare(b.country));
    });
  }

  getArticles(): void {
    this.loading = true;
    this.getArticlesObservable()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((articles) => {
        this.endLazyLoading = articles.length < this.TAKE;
        this.articles.push(...articles);
      });
  }

  getArticlesObservable(): Observable<Article[]> {
    if (this.articleType === ArticleType.Article) {
      return this.articleService.getArticles(this.articles.length, this.TAKE);
    }

    if (this.articleType === ArticleType.Accommodation) {
      return this.articleService.getAccomodations(this.articles.length, this.TAKE);
    }

    return this.articleService.getSetups(this.articles.length, this.TAKE);
  }
}
